export enum TransactionResult {
	SUCCESS = 'success',
	FAILED = 'failed',
}
